<template>
  <form @submit.prevent="update" id="my-account-organization-information">
    <div class="alert -success" v-if="finished">
      <p>Informações alteradas com sucesso!</p>
    </div>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p>Ocorreu um erro desconhecido ao alterar as informações, por favor tente novamente.</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.name.length > 0 }">
      <label for="name" class="label">Nome da Empresa</label>
      <input
        type="text"
        id="name"
        name="companyName"
        class="form-control"
        v-model="form.name"
        autocomplete
        required
      >
      <p class="description" v-if="errors.form.name.length > 0">{{ errors.form.name[0] }}</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.cnpj.length > 0 }">
      <label for="cnpj" class="label">CNPJ</label>
      <input
        type="text"
        id="cnpj"
        name="companyCnpj"
        class="form-control"
        v-mask="'##.###.###/####-##'"
        v-model="form.cnpj"
        autocomplete
        required
      >
      <p class="description" v-if="errors.form.cnpj.length > 0">{{ errors.form.cnpj[0] }}</p>
    </div>

    <div class="flex">
      <button class="btn btn-primary ml-auto" type="submit">Salvar</button>
    </div>

    <loader v-if="loading"/>
  </form>
</template>

<script>
import { mask } from 'vue-the-mask';
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'OrganizationInformation',

  data() {
    const { user } = this.$store.state.auth;

    return {
      loading: false,
      finished: false,
      form: {
        name: user.organization.name,
        cnpj: user.organization.cnpj,
      },
      errors: {
        form: {
          name: [],
          cnpj: [],
        },
      },
    };
  },

  methods: {
    /**
     * Update the organization information.
     *
     * @returns {Promise<void>}
     */
    async update() {
      try {
        this.finished = false;
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/updateOrganizationInformation', this.form);
        await this.$store.dispatch('auth/loadUser');

        this.finished = true;
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;
          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.name = data.errors.name || [];
          this.errors.form.cnpj = data.errors.cnpj || [];
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.name = [];
      this.errors.form.cnpj = [];
      this.errors.unrecognized = false;
    },
  },

  directives: {
    mask,
  },

  components: {
    Loader,
  },
};
</script>

<style scoped>

</style>
